import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import images from '../../utils/images';

function NavBar() {
  const handleCollapse = () => {
    // console.log("handleCollapse");
    var nav = document.getElementById("navbarScroll");
    var btn = document.getElementById("navbarBtn");
    nav.classList.remove("show");
    btn.classList.add("collapsed");
  };
  return (
    <Navbar bg="light" expand="lg">
      <Container className="container">
        <Link className="nav-brand-logo" to="/">
          <img src={images.logo} height="50px" width="50px" alt='logo'/> <h5 className="logo-text">GutC</h5>
        </Link>
        <Navbar.Toggle id='navbarBtn' aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
            <NavLink onClick={handleCollapse} className="nav-link" to="/introduction">
              INTRODUCTION
            </NavLink>
            <NavLink onClick={handleCollapse} className="nav-link" to="/info">
              BASIC INFO
            </NavLink>

            <NavLink onClick={handleCollapse} className="nav-link" to="/explanations">
              EXPLANATIONS
            </NavLink>

            <NavLink onClick={handleCollapse} className="nav-link" activeClassName="activeNavLink" to="/contact-us">
              CONTACT US
            </NavLink>

            <NavLink onClick={handleCollapse} className="nav-link" activeClassName="activeNavLink" to="/about-us">
              About Us
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
